export default __webpack_public_path__ + "graphik-bold.woff2";